import type { Company } from "../hooks/useCompanies.js";

interface Props {
  companies: Company[];
  active: string | null;
  onChange: (id: string) => void;
}

export function CompanyTabs({ companies, active, onChange }: Props) {
  return (
    <div role="tablist" className="flex gap-2 border-b border-slate-200">
      {companies.map((c) => {
        const isActive = c.id === active;
        return (
          <button
            key={c.id}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(c.id)}
            className={
              "px-4 py-2 text-sm border-b-2 -mb-px " +
              (isActive
                ? "border-blue-600 text-blue-700 font-semibold"
                : "border-transparent text-slate-600 hover:text-slate-900")
            }
          >
            {c.name}
          </button>
        );
      })}
    </div>
  );
}
